import {ChangeDetectorRef, Directive, HostListener} from "@angular/core";
import {FUIAbstractInput} from "../../framework/abstract-input";

@Directive()
export class FUIAbstractSwitchInput extends FUIAbstractInput {

    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    /**
     * Switches require a click action to be performed no matter where they
     * are clicked, instead of a focus action that is used on other input types
     */
    @HostListener("click")
    override click(): void {
        this.input.nativeElement.click();
    }

    /**
     * If a user presses enter or space while focussed on the element,
     * use the click method to apply the relevant interaction
     * @param {KeyboardEvent} keyboardEvent
     */
    @HostListener("keypress", ["$event"])
    public keypress(keyboardEvent: KeyboardEvent) {
        if (!this.disabled) {
            if (keyboardEvent.code === "Enter" || keyboardEvent.code === "Space" || keyboardEvent.key === "Enter" || keyboardEvent.key === " ") {
                this.click();
                keyboardEvent.preventDefault();
                keyboardEvent.stopPropagation();
            }
        }
    }

    protected override determineValued(value: any): void {
        this.valued = !!value;
    }
}
